document.addEventListener("DOMContentLoaded", function () {
  var filterTrigger = document.getElementById("filter-trigger");
  if (!filterTrigger) return;

  var filterMenu = document.createElement("div");
  filterMenu.id = "filter-menu";

  // Close button
  var closeBtn = document.createElement("button");
  let storeCloseSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"><path d="M33.28 2.51L30.77 0L16.64 14.13L2.51 0L0 2.51L14.13 16.64L0 30.77L2.51 33.28L16.64 19.15L30.77 33.28L33.28 30.77L19.15 16.64L33.28 2.51Z" fill="#292E3D"/></svg>`;
  closeBtn.innerHTML = storeCloseSvg;
  closeBtn.insertAdjacentHTML("beforeend", '<span class="visually-hidden">Close filter</span>');
  closeBtn.id = "filter-close";
  filterMenu.appendChild(closeBtn);

  // Shop Now button
  var shopBtn = document.createElement("button");
  let storeArrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none"><g fill="#292E3D" clip-path="url(#a)"><path d="M60.035 59.4c-10.919 10.92-28.687 10.92-39.605 0-10.919-10.918-10.904-28.686.007-39.597 10.911-10.912 28.687-10.919 39.605 0 10.919 10.918 10.919 28.686 0 39.605l-.007-.007Zm-37-37c-9.484 9.485-9.484 24.911 0 34.395 9.484 9.485 24.91 9.485 34.395 0 9.484-9.484 9.498-24.91.014-34.394-9.484-9.485-24.925-9.485-34.41 0Z"/><path d="m56.112 36.993-.007.007-12.2-12.2-2.597 2.599L51.67 37.76H23.598l.008 3.681 28.064-.007-10.362 10.362 2.605 2.605 12.2-12.199 2.597-2.598.008-.007-2.606-2.605Z"/></g><defs><clipPath id="a"><path fill="#fff" d="m40.24 0 39.597 39.598L40.24 79.196.642 39.598z"/></clipPath></defs></svg>`;
  shopBtn.innerHTML = "Shop Now" + storeArrowSvg;
  shopBtn.id = "shop-now";

  var tagMapping = {
    "Shop All": "all",
    "Art": "art",
    "Adult Books": "adult-books",
    "Children’s": "children-s",
    "Coffee Table": "coffee-table",
    "Coloring": "coloring",
    "Crafts": "crafts",
    "Creative How-to": "creative-how-to",
    "Food & Drink": "food-drink",
    "Gifts": "gifts",
    "Home & Lifestyle": "home-lifestyle",
    "Memory Books & Journals": "memory-books-journals",
    "Personal Growth": "personal-growth",
    "Puzzles & Games": "puzzles-games"
  };

  var ul = document.createElement("ul");
  ul.id = "filter-list";

  Object.keys(tagMapping).forEach(function (tagLabel) {
    var li = document.createElement("li");
    li.classList.add("filter-item");
    li.dataset.tag = tagMapping[tagLabel];

    var a = document.createElement("a");
    a.textContent = tagLabel;
    a.href = "#";
    a.addEventListener("click", function (e) {
      e.preventDefault();
    });

    li.addEventListener("click", function () {
      li.classList.toggle("selected");

      if (tagLabel === "Shop All" && li.classList.contains("selected")) {
        document.querySelectorAll(".filter-item").forEach(function (el) {
          if (el !== li) el.classList.remove("selected");
        });
      } else if (tagLabel !== "Shop All" && li.classList.contains("selected")) {
        document.querySelectorAll(".filter-item").forEach(function (el) {
          if (el.dataset.tag === "all") el.classList.remove("selected");
        });
      }
    });

    li.appendChild(a);
    ul.appendChild(li);
  });

  filterMenu.appendChild(ul);
  filterMenu.appendChild(shopBtn);
  document.body.appendChild(filterMenu);

  // Toggle modal
  filterTrigger.addEventListener("click", function (e) {
    e.stopPropagation();
    filterMenu.style.display = (filterMenu.style.display === "flex") ? "none" : "flex";
  });

  // Close on outside click
  document.addEventListener("click", function (e) {
    if (!filterMenu.contains(e.target) && e.target !== filterTrigger) {
      filterMenu.style.display = "none";
    }
  });

  // Close on Escape
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      filterMenu.style.display = "none";
    }
  });

  closeBtn.addEventListener("click", function () {
    filterMenu.style.display = "none";
  });

  // ✅ Shopify best practices:
  // 1 tag: /collections/[tag]
  // 2+ tags: /collections/all/tag1+tag2
  shopBtn.addEventListener("click", function () {
    const selectedTags = Array.from(document.querySelectorAll(".filter-item.selected"))
      .map(li => li.dataset.tag)
      .filter(tag => tag !== "all");

    let redirectUrl;

    if (selectedTags.length === 0 || selectedTags.includes("all")) {
      redirectUrl = "/collections/all";
    } else if (selectedTags.length === 1) {
      redirectUrl = "/collections/" + selectedTags[0];
    } else {
      const tagString = selectedTags.join("+");
      redirectUrl = "/collections/all/" + tagString;
    }

    window.location.assign(redirectUrl);
  });
});